"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Animation_1 = require("./class/Animation");
const Blob_1 = require("./class/Blob");
const ModelViewer_1 = require("ts/class/ModelViewer");
const Navbar_1 = require("ts/class/Navbar");
const Videos_1 = require("ts/class/Videos");
const AlignHeaderColumns_1 = require("ts/class/AlignHeaderColumns");
new ModelViewer_1.ModelViewer();
Animation_1.Animations.init();
Blob_1.Blob.init();
Navbar_1.Navbar.init();
Videos_1.Videos.init();
AlignHeaderColumns_1.AlignHeaderColumns.init();
